export default {
    name: 'ChannelsArrangeTools',
    data() {
        return {
            sort: 'activity', // name
            arrange: 'together', // by type
            description: 'preview', // name
        }
    },
    mounted() {
    },
    methods: {}
}
